import { Button } from '@s-group/design-system-components/'
import { IconCommerceShoppingcart } from '@s-group/design-system-icons'
import { SDS_SPACE_MEDIUM } from '@s-group/design-system-tokens/web/tokens/space.es6'
import Link from 'next/link'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

export const StartShoppingButton = () => {
  const { t } = useTranslation()

  return (
    <StyledButtonWrapper>
      <Link href="/?nouto" passHref>
        <Button icon={<IconCommerceShoppingcart />} rounding="small" primary>
          {t('Start shopping')}
        </Button>
      </Link>
    </StyledButtonWrapper>
  )
}

const StyledButtonWrapper = styled.div({
  display: 'flex',
  flexDirection: 'column',
  paddingTop: SDS_SPACE_MEDIUM,
  margin: '0 -20px 0 -20px',

  ['> button > .button-icon']: {
    position: 'relative',
    top: '-1px',
  },
})
